import _ from 'lodash';

const processStrategy = (account) => {
  const relations = {};
  const omit = [];
  return { ..._.omit(account, omit), ..._.pickBy(relations, _.identity) };
};

export default {
  key: 'shipment',
  definition: {},
  processStrategy,
};
